import { Box } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import CategoryCreate from "pages/product_category/CategoryCreate";
import React from "react";

const UpdateCategoryDialog = ({ open, handleClose, category, fullGrid }) => {
  return (
    <CustomDialog
      forceFullScreen={true}
      open={open}
      handleClose={handleClose}
      heading="Update category"
    >
      <Box padding={2}>
        <CategoryCreate category={category} fullGrid={fullGrid} />
      </Box>
    </CustomDialog>
  );
};

export default UpdateCategoryDialog;
